var render = function render(){var _vm=this,_c=_vm._self._c;return _c('t-layout',{staticClass:"page"},[_c('div',{staticClass:"info"},[_c('div',{staticClass:"item",on:{"click":_vm.toShopCoupon}},[_vm._v("商户优惠券")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }